/**
 * DevExtreme (esm/renovation/ui/scroll_view/utils/get_scroll_left_max.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function getScrollLeftMax(element) {
    return element.scrollWidth - element.clientWidth
}
